<template>
  <v-card class="pa-8">
    <v-row>
      <v-col cols="12">
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row justify="center">
            <v-col cols="12">
              <v-text-field
                label="Название"
                required
                :rules="notEmptyRules"
                v-model="title"
                name="title"
                type="text"
              ></v-text-field>
              <v-col aling-self-right>
                <v-btn @click="save" color="primary">Сохранить</v-btn>
              </v-col>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-text class="text-lg-center">
          <v-text-field v-model="albumSearch" label="Поиск"></v-text-field>
          <v-row>
            <transition-group
              name="slide-x-transition"
              tag="div"
              role="list"
              class="v-list v-list-two-line"
            >
              <v-list-item v-for="m in albumList" :key="m.id" avatar @click="selectAlbum(m)">
                <v-list-item-avatar v-if="m.cover.sizes">
                  <img :src="m.cover.sizes['50']" />
                </v-list-item-avatar>
                <v-list-item-content style="cursor: pointer">
                  <v-list-item-title v-html="m.title"></v-list-item-title>
                  <v-list-item-subtitle v-html="m.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </transition-group>
          </v-row>
        </v-card-text>
        <v-card-text> </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-lg-center">
          <v-col cols="12" align-self-center>
            <v-btn color="success" @click="modal = false">Закрыть</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import api from '@/mixins/api'

export default {
  name: 'AlbumEdit',
  mixins: [api],
  data() {
    return {
      modal: false,
      parentTitle: '',
      parent: null,
      parent_id: 0,
      albumSearch: '',
      albumList: [],
      title: '',
      description: '',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      images: [],
      valid: true,
      published: false,
      on_top: false,
      group_by_date: false,
      notEmptyRules: [(v) => !!v || 'Это поле обязательно'],
    }
  },
  watch: {
    albumSearch() {
      this.searchAlbum()
    },
  },
  mounted() {
    // this.siteKey = this.$attrs.site_key
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return
      }
      const formData = new FormData(this.$refs.form.$el)
      for (let pair of formData.entries()) {
        this.$log.debug(pair[0] + ', ' + pair[1])
      }
      this.axios({
        url: '/v1/albums',
        method: 'post',
        data: {
          title: this.title,
          description: this.description,
          parent_id: this.parent_id,
          site_key: this.$attrs.site_key,
        },
      })
        .then((resp) => {
          this.$router.push({ name: 'photo_albums_edit', params: { id: resp.data.id } })
        })
        .catch((err) => {
          this.$log.error('create album', err.response)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    selectAlbum(e) {
      this.parent = e
      this.parentTitle = e.title
      this.parent_id = e.id
      this.modal = false
    },
    searchAlbum() {
      if (!this.albumSearch) {
        this.albumList = []
        return
      }

      this.axios({
        url: '/v1/albums',
        method: 'get',
        params: { title_contains: this.albumSearch, site_key: this.$attrs.site_key },
      })
        .then((resp) => {
          const data = resp.data
          this.albumList = data ? data : []
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    removeParent() {
      this.parent = {}
      this.parentTitle = ''
    },
  },
}
</script>
